export interface ISavedMenuData {
  menuId: string;
  startTime: Date | string;
}

export const getMenuDataToSave = (id: string, savedMenuData: ISavedMenuData[] | null) => {
  const menuData: ISavedMenuData = {
    menuId: id,
    startTime: new Date(),
  };

  let dataToSave: ISavedMenuData[] = [menuData];

  if (savedMenuData) {
    const savedMenuDataIndex = savedMenuData.findIndex((savedData: ISavedMenuData) => savedData.menuId === id);

    if (savedMenuDataIndex === -1) {
      dataToSave = [...savedMenuData, menuData]; // adds new menu data
    } else {
      const savedData = [...savedMenuData];
      savedData.splice(savedMenuDataIndex, 1, menuData); // replaces existing menu data
      dataToSave = savedData;
    }
  }

  return dataToSave;
};
